import React from 'react';
import { ChevronDown } from 'lucide-react';

export const AdminSelect = ({ children, ...props }) => <div className="admin-select-wrap">
  <select {...props}>{children}</select><ChevronDown size={14} aria-hidden="true" className="admin-select-caret" />
</div>;